import axios from "axios";

import Session from "./Session";
import { LogError, LogMessage } from "../AppUtil/AppUtil";

const AppConfig = window.AppConfig;
const TRANSACTIONS = window.AppConfig.TRANSACTIONS;

export default class TransactionService {
  static async create(requestBody) {
    return this.PostData(TRANSACTIONS.CREATE, requestBody, "accounts");
  }

  /**
   * This function is used to make POST Request from Application.
   * @param url
   * @param data
   * @param headers
   * @return {Promise<*>}
   * @constructor
   */

  static async PostData(url, data, urlKey = "default", isLoggedIn = true) {
    try {
      const URL = AppConfig.API_URL[urlKey] + url;
      const params = {};
      if (isLoggedIn) {
        params.headers = {
          Authorization: `Bearer ${Session.getAccessToken()}`,
        };
      }
      LogMessage(
        `Making Post Request to url: = ${URL} data ${JSON.stringify(data)}`
      );
      const response = await axios.post(URL, data, params);

      return;
    } catch (err) {
      LogError(err.message);
      console.log(err.message);
      if (this.checkIfSessionExpired(err.message)) {
        this.logout(
          "app_message.session_expired",
          "app_message.session_expired_message"
        );
      }
    }
  }
}
